module.exports = __webpack_public_path__ + "img/RedPanda.9ee389ad.jpg";